"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _EpicSubscription = require("./EpicSubscription.scss");

var _EpicSubscription2 = _interopRequireDefault(_EpicSubscription);

var _EpicSubscriptionLogin = require("./EpicSubscriptionLogin");

var _EpicSubscriptionLogin2 = _interopRequireDefault(_EpicSubscriptionLogin);

var _EpicSubscriptionSubscribe = require("./EpicSubscriptionSubscribe");

var _EpicSubscriptionSubscribe2 = _interopRequireDefault(_EpicSubscriptionSubscribe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EpicSubscription = function (_React$Component) {
  (0, _inherits3.default)(EpicSubscription, _React$Component);

  function EpicSubscription() {
    (0, _classCallCheck3.default)(this, EpicSubscription);
    return (0, _possibleConstructorReturn3.default)(this, (EpicSubscription.__proto__ || (0, _getPrototypeOf2.default)(EpicSubscription)).apply(this, arguments));
  }

  (0, _createClass3.default)(EpicSubscription, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          subscriptionError = _props.subscriptionError,
          isEpicLogin = _props.isEpicLogin,
          hasUnrealLicense = _props.hasUnrealLicense,
          subscribeToUnrealUnlimited = _props.subscribeToUnrealUnlimited,
          subscribing = _props.subscribing;


      return _react2.default.createElement(
        "section",
        null,
        _react2.default.createElement(
          "h1",
          { className: _EpicSubscription2.default.heading },
          "Quixel is part of the Epic Games family"
        ),
        !isEpicLogin ? _react2.default.createElement(_EpicSubscriptionLogin2.default, null) : _react2.default.createElement(_EpicSubscriptionSubscribe2.default, {
          subscriptionError: subscriptionError,
          subscribing: subscribing,
          subscribeToUnrealUnlimited: subscribeToUnrealUnlimited
        })
      );
    }
  }]);
  return EpicSubscription;
}(_react2.default.Component);

exports.default = EpicSubscription;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscription.jsx
// module id = 2624
// module chunks = 0